/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Department_LabelInputs */

const en_cv_extract_form_department_label = /** @type {(inputs: Cv_Extract_Form_Department_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faculty`)
};

const de_cv_extract_form_department_label = /** @type {(inputs: Cv_Extract_Form_Department_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fachbereich`)
};

/**
* | output |
* | --- |
* | "Faculty" |
*
* @param {Cv_Extract_Form_Department_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cv_extract_form_department_label = /** @type {((inputs?: Cv_Extract_Form_Department_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Department_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_department_label(inputs)
	return en_cv_extract_form_department_label(inputs)
});